import DataSelect from './DataSelect';

export default DataSelect;



// WEBPACK FOOTER //
// ./src/containers/DataSelect/index.js